<template>
    <footer>
        © Copyright {{year}} icare 3+1 - All Rights Reserved
    </footer>
</template>
<script>
    import moment from 'moment'
    export default {
        name: 'Footer',
        data(){
            return {
                year: moment().year(),
            }
        },
        
    }
</script>
<style>
footer{
    width: 100%;
    text-align: center;
    font-size: 10px;
    padding: 10px;
    position: absolute;
    bottom: 0;
}
</style>